import firebase from "firebase/app";
import "firebase/messaging";

const config = {
  apiKey: "AIzaSyCdO7CvG3jWAhnT4jUCYxeyXrqQNNX9fvA",
  authDomain: "brandificationdev.firebaseapp.com",
  projectId: "brandificationdev",
  storageBucket: "brandificationdev.appspot.com",
  messagingSenderId: "764246147100",
  appId: "1:764246147100:web:96d23d85f9b4fce043dfd9",
};

firebase.initializeApp(config);
const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;

messaging &&
  messaging.onMessage(function (payload) {
    navigator.serviceWorker.register("/serviceworker/firebase-messaging-sw.js");
    Notification.requestPermission(function (permission) {
      if (permission === "granted") {
        navigator.serviceWorker.ready
          .then(function (registration) {
            payload.data.data = JSON.parse(JSON.stringify(payload.data));

            registration.showNotification(payload.data.title, payload.data);
          })
          .catch(function (error) {
            console.error("ServiceWorker registration failed", error);
          });
      }
    });
  });

export const requestFirebaseNotificationPermission = params => {
  let param = {};
  if (params && params.useVapid) {
    param = { vapidKey: process.env.VAPID_KEY };
  }
  return (
    messaging &&
    messaging.requestPermission().then(function () {
      return messaging
        .getToken(param)
        .then(firebaseToken => {
          return firebaseToken;
        })
        .catch(err => {
          if (err.code === "messaging/token-subscribe-failed") {
            return requestFirebaseNotificationPermission({ useVapid: true });
          }
          console.error(err && err.message);
        });
    })
  );
};
